import {
  IApplyOptionsCommonSearchParam,
  IOmsResultTableReport,
} from "src/Interfaces/applyOption";
import { getOmsResultTable } from "src/Requests/applyOption";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";

interface IProps {
  searchParams: IApplyOptionsCommonSearchParam;
  refreshFlag?: boolean;
}

const OmsResultTable = ({ searchParams, refreshFlag }: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, IOmsResultTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getOmsResultTable}
      searchParameters={searchParams}
      pagesize={200}
      withSort
    />
  );
};

export default OmsResultTable;
